// GENERATE BY ./scripts/generate.ts
// DON NOT EDIT IT MANUALLY
import * as React from 'react';
import FolderOpenFilledSvg from "@ant-design/icons-svg/es/asn/FolderOpenFilled";
import AntdIcon from '../components/AntdIcon';

var FolderOpenFilled = function FolderOpenFilled(props, ref) {
  return React.createElement(AntdIcon, Object.assign({}, props, {
    ref: ref,
    icon: FolderOpenFilledSvg
  }));
};

FolderOpenFilled.displayName = 'FolderOpenFilled';
export default React.forwardRef(FolderOpenFilled);


//////////////////
// WEBPACK FOOTER
// ./node_modules/_@ant-design_icons@4.0.6@@ant-design/icons/es/icons/FolderOpenFilled.js
// module id = 1195
// module chunks = 0